<script>
    import _ from "lodash";

    export default {
        methods: {
            coeffRate(data) {
                return data.out3sfp.sfp;
            },
            find(data) {
                let display = [
                    {
                        is: function (x) {
                            return x >= 4.25;
                        },
                        msg: 'Превосходный',
                        variant: 'success'
                    },
                    {
                        is: function (x) {
                            return _.inRange(x, 3.25, 4.25);
                        },
                        msg: 'Высокий',
                        variant: 'warning'
                    },
                    {
                        is: function (x) {
                            return _.inRange(x, 2.25, 3.25);
                        },
                        msg: 'Средний',
                        variant: 'primary'
                    },
                    {
                        is: function (x) {
                            return _.inRange(x, 1.25, 2.25);
                        },
                        msg: 'Недостаточный',
                        variant: 'danger'
                    },
                    {
                        is: function (x) {
                            return x < 1.25;
                        },
                        msg: 'Неудовлетворительный',
                        variant: 'dark'
                    }
                ];
                let vm = this;
                return _.find(display, function (d) {
                    return d.is(vm.coeffRate(data));
                });
            },
            variant(data) {
                return data.out3sfp ? this.find(data).variant : '';
            },
        }
    }
</script>